export enum RADIO_GROUP_INPUT_TEST_IDS {
	ROOT = 'RADIO_GROUP_INPUT_ROOT',

	INPUT = 'RADIO_GROUP_INPUT_INPUT',
	LABEL = 'RADIO_GROUP_INPUT_LABEL',
}
